module.exports = __webpack_public_path__ + "static/media/install-shopify-app.5204c2a2.webp";